<template>
    <div class="card">
        <a id="show-modal" @click="mudarOportunidade(item);" title="Noma da empresa">
			<!-- Ajuste rápido black friday -->
			<div class="card-img-top card-background" v-if="this.item.IdOportunidade == 12345 || this.item.IdOportunidade == 12320 || this.item.IdOportunidade == 12264 || this.item.IdOportunidade == 12005 || this.item.IdOportunidade == 11668" :class="{blackfriday: true}">
                <div class="badge badge-id">ID: {{ajustIdOportunidade(this.item.IdOportunidade,5)}}</div>
                <img src="/static/assets/images/transparent.png" class="card-img-top">
                <h2>{{ item.Empresa.NomeFantasia ? item.Empresa.NomeFantasia : formatarScore(item.Score)}}</h2>
                <div class="rating">
                    <span class="circle">{{formatarScore(item.Score)}}</span>
                </div>
            </div>
            <div class="card-img-top card-background" v-else>
                <div class="badge badge-id">ID: {{ajustIdOportunidade(this.item.IdOportunidade,5)}}</div>
                <img src="/static/assets/images/transparent.png" class="card-img-top">
				<img src="/static/assets/images/selo-garantia.png" class="selo-garantia" title="Oportunidade com garantia pelo tomador e indicada pelo canal BNDES" v-if="item.Garantia == 'Sim'">
                <h2>{{ item.Empresa.NomeFantasia ? item.Empresa.NomeFantasia : formatarScore(item.Score)}}</h2>
                <div class="rating">
                    <span class="circle">{{formatarScore(item.Score)}}</span>
                </div>
            </div>
        </a>
        <div class="card-body">
            <dd class="cat">{{formatarTipoEmprestimo(item.TipoEmprestimo)}}</dd>
            <dt>Valor solicitado</dt>
            <dd class="value">R$ {{money(item.Valor)}}</dd>
            <dd>
                <div class="progress">
                    <div class="progress-bar" role="progressbar" :style="'width: ' + inteiro(levantado(item)) + '%'" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                        <span class="progress-value">{{money(levantado(item))}}%</span>
                    </div>
                </div>
                <p class="small">Faltam:
                    <strong>R$ {{money(faltam(item))}}</strong>
                </p>
            </dd>
            <dd v-if="!item.Encerrado" class="end">Termina em <strong>{{ diffDate(item.FimCaptacao) }}</strong></dd>
            <dd class="end" v-else>Encerrado</dd>
        </div>
        <div class="card-footer d-flex align-items-center">
            <div class="tax">
                <strong>Rendimento</strong>
                <span > {{valor(item.Rendimento)}}% a.a.</span>
            </div>
            <div class="links">
                <button :id="'buttonInvestmentList'+index" v-if="!item.Encerrado && item.TipoEmprestimo != 'emprestimo-ccb'" @click="mudarOportunidade(item);" class="btn btn-primary btn-block"
                    title="Investir">{{(item.Valor - (item.ValorCaptado == undefined ? 0 :item.ValorCaptado) ) > 0 ? 'Investir' : 'Lista de Espera'}}</button>
                <!-- <a href="#" v-if="!item.Encerrado && item.TipoEmprestimo == 'emprestimo-ccb'" @click="mudarOportunidade(item);" class="btn btn-primary btn-block" title="Investir">Investir</a> -->
                <button v-if="item.Encerrado" @click="mudarOportunidade(item);" class="btn btn-secondary btn-block" title="Encerrado">Encerrado</button>

                <router-link v-if="item.TipoEmprestimo != 'emprestimo-ccb'" :to="templateRender(item)" class="btn btn-outline-primary btn-block" title="+ detalhes">+ detalhes</router-link>
                <router-link v-else :to="'/investimentos/oportunidades/'+item._id+'/perfil-ccb'" class="btn btn-outline-primary btn-block" title="+ detalhes">+ detalhes</router-link>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props:{
			index: { type:Number },
            item:{ type: Object },
            mudarOportunidade:{ type: Function },
            ajustIdOportunidade:{ type: Function },
            formatarScore:{ type: Function },
            formatarTipoEmprestimo:{ type: Function },
            money:{ type: Function },
            inteiro:{ type: Function },
            levantado:{ type: Function },
            faltam:{ type: Function },
            diffDate:{ type: Function },
            valor:{ type: Function },
            templateRender:{ type: Function }
		},
    }
</script>
<style lang="scss" scoped>
	@import "../assets/styles/iouu/variables";
	@import "../assets/styles/iouu/mixins";

	.view .cards .card-background.blackfriday {
		background: #151515 !important;
	}

	.card-background {
		position: relative;
	}

	.card-background .selo-garantia {
		position: absolute;
		top: 0;
		right: 10px;
		height: 65px;
	}

	.card-background .selo-bndes {
		height: 60px;
		top: -3px;
		position: absolute;
		right: 10px;
	}

	@media only screen and (max-width: 1024px) {
		.card-background .selo-bndes {
			height: 50px;
		}
	}
		
	@include mobile {
		.card {
			margin-left: 15px;
			margin-right: 15px;
		}
	}

	.tit_page {
		h1 {
			@include xs {
				font-size: calcRem(25);
			}
		}

		.float-right {
			// padding-top: 1rem;
		}
	}

	.btn-modal {

		padding-top: 25px;

		.btn {
			padding:0px;
			margin:0px;
			border:none;
			padding-left: 30px;
			padding-right: 30px;
			line-height: 40px;
			text-transform: uppercase;
			font-weight: bold;
			@include font-size(16px);

		}

		@include xs {
			.btn {
				display: block;
				line-height: 35px;
				@include font-size(13px);

				&-primary {
					margin-bottom: 10px;
				}
			}
		}

		@include sm {
			.btn {
				display: block;
				line-height: 35px;
				@include font-size(13px);

				&-primary {
					margin-bottom: 10px;
				}
			}
		}

		@include ds {
			padding-top: 15px;

			.btn {
				line-height: 30px;
				padding-left: 20px;
				padding-right: 20px;
				@include font-size(13px);
			}
		}
	}
	
	table {
		border: none !important;
		th,
		td {
			text-align: center; // MEDIA max: 1199px
			@include brkp-01(1199px) {
				font-size: calcRem(12);
			}

			&:nth-child(1) {
				@include brkp-01(991px) {}
			}

			&:nth-child(2) {
				@include brkp-01(991px) {
					display: none;
				}
			}

			&:nth-child(3) {
				// MEDIA max: 1199px
				@include brkp-01(1199px) {
					display: none;
				}
			}

			&:nth-child(4) {
				@include brkp-01(991px) {
					width: 140px;
				}
			}

			&:nth-child(5) {
				@include brkp-01(991px) {
					width: 80px;
				}

				@include sm {
					display: none;
				}

				@include xs {
					display: none;
				}
			}

			&:nth-child(6) {
				// MEDIA max: 1199px
				@include brkp-01(1199px) {
					width: 135px;
				}

				@include sm {
					display: none;
				}

				@include xs {
					display: none;
				}
			}

			&:nth-child(7) {
				@include brkp-01(991px) {
					display: none;
				}
			}

			&:nth-child(8) {
				@include brkp-01(991px) {

					br {
						display: none;
					}

					a {
						&.btn-primary {
							font-size: calcRem(10);
							padding: .25rem .5rem;
							width: 112px;
						}

						&.btn-secondary {
							font-size: calcRem(10);
							padding: .25rem .5rem;
							width: 112px;
						}

						&.btn-link {
							width: 100%;
						}
					}
				}

				@include xs {
					& {
						width: 135px;
					}
				}
			}

		}

		th {
			border-top: none;
		}

		tr {
			border-bottom: 1px solid #e9ecef !important;
		}

		td {
			color: #666;
		}

		p {
			margin: 0px;
			padding: 0px;
			&.small {
				color: #888;
				font-size: 12px;
				font-weight: normal;
				line-height: 16px;
				padding-top: 5px;
			}
		}

		.rating {
			.score {
				display: inline-block;
				width: 40px;
				height: 40px;
				padding: 0px;
				border-radius: 50%;
				line-height: 40px;
				font-weight: bold;
				color: #fff;
				text-transform: uppercase; // MEDIA max: 991px
				@include brkp-01(991px) {
					width: 25px;
					height: 25px;
					line-height: 25px;
				}
			}
		}
	}

	.btn {
		&-primary {
			background: $btn-invest;
			font-weight: bold;
			text-transform: uppercase;
			border: none;
			padding-left: 20px;
			padding-right: 20px;
			&:hover {
				background: darken($btn-invest, 5%);
			} // MEDIA max: 1199px
			@include brkp-01(1199px) {
				font-size: calcRem(12);
			}
		}

		&-link {
			color: #666;
			&:hover {
				color: #999;
				text-decoration: underline !important;
			} // MEDIA max: 1199px
			@include brkp-01(1199px) {
				font-size: calcRem(12);
			}
		}
	}

	.tit {
		border: none !important;
		float: left;
		margin-bottom: 0px !important;
		padding-bottom: 0px !important;

		h2 {
			font-size: 30px !important;
			margin-right: 20px;
		}

		.rating {
			position: relative;
			top: -2px !important;
		}

		small {
			display: inline-block;
			font-size: 15px !important;
			padding-top: 10px;
		}
	}

	.items {
		.margin {
			border-right: 1px solid #ddd;
			padding-right: 30px;
		}

		.item {
			border-bottom: 1px solid #ddd;
			padding: 15px 0;
			&__info {
				color: #888;
				@include font-size(16px);
				strong {
					color: #000;
				}
			}

			span {
				margin: 0;
				padding: 0;
			}

			&:first-child {
				padding-top: 0px;
			}

			&:last-child {
				border-bottom: none;
				padding-bottom: 0px;
			}

			p {
				padding: 0px;
				margin: 0px;
				color: #888;
				strong {
					color: #000;
				}
			}

			.progress {
				margin: 10px 0;
				height: 20px!important;
			}

			.small {
				font-size: 13px;
				color: #888;
				margin: 0px;
				padding: 0px;
			}

			form {
				margin-bottom: 20px;
			}

			.confirm {
				margin: 20px 0;
				img {
					width: 40px;
					display: block;
					margin-top: 6px;
					margin-right: 10px;
				}

				p {
					display: table;
					a {
						color: #888;
						text-decoration: underline !important;
						font-weight: bold;
						&:hover {
							color: #666;
						}
					}
				}
			}

			.alert {
				.btn {
					margin-top: 0px;
				}
				a:hover {
					color: #856404;
				}
			}

			a {
				&.item__link {
					float: left;
					@include font-size(22px);
					line-height: 30px;
					color: #888;
					position: relative;
					&:hover {
						color: $c3;
					}
					@include xs {
						@include font-size(18px);
					}
				}

				i {
					background: url(/static/assets/images/ico-separador.svg) no-repeat right center;
					background-size: 8px;
					width: 20px;
					line-height: 30px;
					position: absolute;
					top: 0;
					right: -20px;

					@include xs {
						background-size: 6px;
						width: 18px;
						line-height: 30px;
					}
				}
			}

			.form-row {
				label {
					color: #000 !important;
					padding-bottom: 10px;
				}

				input {
					margin-bottom: 0px;
					box-shadow: none !important;
					height: 50px;
				}

				button {
					height: 50px;
					@include font-size(18px);
				}
			}
		}
	}

	.btn-link {
		padding: 0px;
	} // ESTILO PARA DESKTOP
	@include ds {

		.tit_page {

			h1 {
				@include font-size(25px);
				margin: 0px;
				padding: 0px;
			}

			.float-right {
				padding-top: 8px;
			}
		}

		table {

			th {
				@include font-size(13px);
			}

			td {
				@include font-size(13px);
			}

			p {
				&.small {
					font-size: 10px;
					line-height: 8px;
				}
			}

			.rating {
				.score {
					width: 30px;
					height: 30px;
					border-radius: 50%;
					line-height: 30px;
				}
			}
		}

		.progress {
			height: 20px!important;
			font-size: 8px;
			line-height: 8px;
		}

		.btn {
			@include font-size(13px);
			text-transform: uppercase;
			font-weight: bold;

			&-primary {
				padding: 6px 15px;
			}
			&-danger {
				padding: 6px 15px;
			}
		} // MODAL
		.tit {

			h2 {
				font-size: 18px !important;
			}
			small {
				font-size: 12px !important;
				padding-top: 5px;
			}
		}


		.box {
			padding: 10px;
		}

		.items {

			.item {
				padding: 10px 0;

				.small {
					font-size: 10px;
				}

				&__info {
					@include font-size(10px);
				}

				a {
					&.item__link {
						@include font-size(14px);
						line-height: 20px;
					}

					i {
						background-size: 5px;
						width: 11px;
						line-height: 20px;
						top: 0;
						right: -15px;
					}
				}

				label {
					font-size: 9px !important;
					padding-bottom: 5px;
				}


				.form-row {

					input {
						@include font-size(16px);
						height: 40px;
					}

					button {
						height: 40px;
						@include font-size(14px);
					}

				}

				.alert {
					h2 {
						background: none;
						padding: 0px;
						font-size: 18px;
					}

					p {
						padding-bottom: 10px;
					}

					.btn {
						width: 80% !important;
						margin: 0 10%;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/OpportunityCard.vue